import React, { memo } from 'react';
import './index.less';
import classnames from 'classnames';
import ABSParagraph from '../../ABSParagraph';

export interface IABSFieldDescProps {
  desc?: React.ReactNode;
  className?: string;
}

const ABSFieldDesc: React.FC<IABSFieldDescProps> = props => {
  const { desc = '', className } = props;

  if (!desc) {
    return null;
  }

  const classes = classnames('abs-content-description', className);

  return <ABSParagraph className={classes}>{desc}</ABSParagraph>;
};

export default memo(ABSFieldDesc);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSField/Desc/index.tsx